import React from 'react';

export const Spinner: React.FC = () => {
  return (
    <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900"></div>
  );
};
